import { v4 } from "uuid";
import { getUserId } from "./browser";
// use same format as Segment to avoid breaking changes
export const getMessageId = () => `ajs-next-${v4().replace(/-/g, "")}`;
// Looks for password=whatever(&). and PII related params.
// Used for removing password and PII query params from page context
const queryParamsRegex = /((?:pass|pw|password|email|firstname|lastname)=[^&]+&*)/gi;
/**
 * These utils are used for both browser and web worker environments, so it CANNOT contain any DOM elements for WW compatibility
 * Using Web Workers: https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Using_web_workers
 * @param pageData
 */
export function getCampaignInfo(pageData) {
    // https://en.wikipedia.org/wiki/UTM_parameters
    const utmKeys = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content",
    ];
    const campaignInfo = {};
    const url = (pageData === null || pageData === void 0 ? void 0 : pageData.referrer.includes("utm_"))
        ? pageData === null || pageData === void 0 ? void 0 : pageData.referrer
        : pageData === null || pageData === void 0 ? void 0 : pageData.url;
    const search = url === null || url === void 0 ? void 0 : url.split("?")[1];
    const params = new URLSearchParams(search);
    utmKeys.forEach((key) => {
        const utmVal = params.get(key);
        if (utmVal) {
            // strip `utm_` prefix for segment context.campaign: https://segment.com/docs/connections/spec/common/#context
            const formattedKey = key === "utm_campaign" ? "name" : key.split("utm_")[1];
            campaignInfo[formattedKey] = utmVal;
        }
    });
    return campaignInfo;
}
/**
 * Processes event context page data and removes the password / PII query
 * param and value, if present
 * @param pageData The event context page data object
 * @returns A clean event context page data object, with password / PII query params removed
 */
export function cleanPageData(pageData) {
    if (typeof pageData === "undefined") {
        return;
    }
    const cleanCopy = Object.assign({}, pageData);
    for (let prop in cleanCopy) {
        const val = cleanCopy[prop];
        cleanCopy[prop] = val.replace(queryParamsRegex, "");
    }
    return cleanCopy;
}
export function getEventPayload(options) {
    var _a, _b;
    const context = options.context;
    const pageCtx = context === null || context === void 0 ? void 0 : context.page;
    const currentTime = new Date().toISOString();
    const userId = options.userId || ((_a = context === null || context === void 0 ? void 0 : context.traits) === null || _a === void 0 ? void 0 : _a.id);
    return {
        ...options,
        context: {
            ...context,
            campaign: getCampaignInfo(pageCtx),
            page: cleanPageData(pageCtx),
        },
        userId: userId ? String(userId) : (_b = getUserId()) !== null && _b !== void 0 ? _b : null,
        messageId: options.messageId || getMessageId(),
        sentAt: currentTime,
        timestamp: currentTime,
    };
}
export function safeJsonParse(text) {
    let str = text || "";
    try {
        str = JSON.parse(str);
    }
    catch (e) {
        // noop
    }
    return str;
}
